<script setup>
import DistributionChart from "./DistributionChart.vue";

const props = defineProps({
    stat: {
        type: Object,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
    chartColor: {
        type: String,
        required: false,
        default: '#666666',
    }
})

</script>

<template>
    <div
        v-if="stat"
        :class="[type === 'distribution' ? 'col-span-6' : '', ['min', 'max'].includes(type) ? 'col-span-3' : 'col-span-3', ['count', 'average', 'median'].includes(type) ? 'col-span-3' : 'col-span-3']"
    >
        <card-basic
            class="!mb-0"
        >
            <div
                v-if="type === 'distribution'"
            >
                <distribution-chart
                    :stat="stat"
                    :chart-color="chartColor"
                />
            </div>
            <div
                v-else-if="!type?.includes('raw')"
                class="text-2xl text-center"
            >
                {{ stat }}
            </div>
            <div class="text-center mt-2">{{ _mft('form:statistics.type.'+type+'.title') }}</div>
        </card-basic>
    </div>
</template>

<style scoped>

</style>
